import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPendingPOs,
  fetchPODetails,
} from "./thunk";

interface PendingPOState {
  list: any[];
  detail: any | null;
  loading: boolean;
  error: string | null;
  rowCount: number;
  selectedPO: any | null
  itemDetails: any[];
  poDetails: any | null;
  successMessage: string | null;
}

const initialState: PendingPOState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  rowCount: 0,
  selectedPO: null,
  itemDetails: [],
  poDetails: null,
  successMessage: null,
};

const pendingPOSlice = createSlice({
  name: "pendingPO",
  initialState,
  reducers: {
    resetPendingPOState: () => initialState,
  },
  extraReducers: (builder) => {
    // ✅ Fetch Pending POs
    builder
      .addCase(fetchPendingPOs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingPOs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPendingPOs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch pending POs";
      });

    // ✅ PO Details
    builder
      .addCase(fetchPODetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPODetails.fulfilled, (state, action) => {
        state.loading = false;
        state.poDetails = action.payload;
      })
      .addCase(fetchPODetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || "Failed to fetch PO details";
      });
  },
});

export const { resetPendingPOState } = pendingPOSlice.actions;
export default pendingPOSlice.reducer;
